import { For } from "solid-js";

export const ChatHomepagePlatformDropdown = () => {
  const data = [
    {
      column_title: "EXPLORE",
      column_description: "Turn unstructured data into clarity",
      links: [
        {
          text: "Turn Data Chaos to Action",
          description: "Go from cross-source data to decisive action.",
          href: "https://web.storytell.ai/every-file-meaningful-insights",
        },
        {
          text: "Context-Aware Intelligence",
          description: "AI that understands your org’s language and context.",
          href: "https://web.storytell.ai/gain-contextual-intelligence",
        },
        {
          text: "Concepts Coming Soon",
          description: "Dynamically organize unstructured data into reusable Concepts",
          href: "https://web.storytell.ai/concepts",
        },
        {
          text: "Trust but Verify",
          description: "Validate every answer with sources and evidence",
          href: "https://web.storytell.ai/trust-but-verify",
        },
      ],
    },
    {
      column_title: "ACT",
      column_description: "Turn insight into action—fast",
      links: [
        {
          text: "Get Better Answers",
          description: "Refine prompts, ask follow-ups and dig deeper all in one-click",
          href: "https://web.storytell.ai/get-better-answers",
        },
        {
          text: "Dynamic LLM Router",
          description: "Get the perfect answer, every time",
          href: "https://web.storytell.ai/llm-router",
        },
        {
          text: "Actions Coming Soon",
          description: "Automate next steps from live insights—alerts, actions, follow-ups.",
          href: "https://web.storytell.ai/actions",
        },
        {
          text: "Personalized AI Coming Soon",
          description: "Tailor Storytell to work like a teammate.",
          href: "https://web.storytell.ai/personalized-ai",
        },
      ],
    },
    {
      column_title: "COLLABORATE",
      column_description: "Work smarter together with shared intelligence",
      links: [
        {
          text: "Collections Storytell Legacy",
          description: "Save, organize, and share insights across teams",
          href: "https://web.storytell.ai/create-team-project-spaces",
        },
        {
          text: "De-Silo Teams",
          description: "Connect files, chats, and context across the org",
          href: "https://web.storytell.ai/de-silo-teams",
        },
      ],
    },
    {
      column_title: "SECURITY & CONTROL",
      column_description: "Control how Storytell works for your org",
      links: [
        {
          text: "Trust & Security",
          description: "Stay compliant with enterprise-grade governance",
          href: "https://web.storytell.ai/trust-and-security",
        },
        {
          text: "Cost Management",
          description: "Track & optimize AI usage by team & use case",
          href: "https://web.storytell.ai/manage-costs",
        },
        {
          text: "Enterprise Controls Coming Soon",
          description: "Manage teams, access levels, and data flow",
          href: "https://web.storytell.ai/enterprise-controls",
        },
      ],
    },
    {
      column_title: "RESOURCES",
      column_description: "Guides, prompts, events & tools to build with Storytell",
      links: [
        {
          text: "Why Storytell",
          description: "Weigh buying a platform vs in‑house enterprise AI",
          href: "https://web.storytell.ai/buy-vs-build-enterprise-ai",
        },
        {
          text: "Documentation",
          description: "Get started with Storytell’s developer docs",
          href: "https://docs.storytell.ai/",
        },
        {
          text: "Blog",
          description: "Insights from the team building Storytell",
          href: "https://web.storytell.ai/blog",
        },
        {
          text: "Webinars & Workshops",
          description: "Live & on‑demand sessions on AI, prompting, ethics & more",
          href: "https://web.storytell.ai/webinars",
        },
        {
          text: "AI Prompt Library",
          description: "Curated prompts to get better results from Storytell",
          href: "https://web.storytell.ai/prompts",
        },
      ],
    },
  ];
  return (
    <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 max-w-6xl gap-2 py-4 px-4">
      <For each={data}>
        {(col) => (
          <div class="flex flex-col gap-2">
            <div class="p-2">
              <h3 class="font-medium text-sm mb-1 bg-gradient-to-r from-violet-500 to-blue-500 dark:from-violet-400 dark:to-blue-400 text-transparent bg-clip-text">
                {col.column_title}
              </h3>
              <p class="text-xs text-muted-text">{col.column_description}</p>
            </div>
            <For each={col.links}>
              {(link) => (
                <a
                  href={link.href}
                  target="_blank"
                  class="hover:text-violet-400 dark:hover:text-violet-400 hover:bg-panel-hover p-2 rounded-lg"
                  rel="noreferrer"
                >
                  <p class="font-medium">{link.text}</p>
                  <p class="text-xs text-muted-text">{link.description}</p>
                </a>
              )}
            </For>
          </div>
        )}
      </For>
    </div>
  );
};
